"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductLayoutOfThree = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const views_1 = require("./views");
const productTile_1 = require("../productTile");
function ProductLayoutOfThree({ layout, className, }) {
    const { data } = (0, app_1.useQuery)('getProducts', {
        args: { take: 3 },
        select: {
            slug: true,
            title: true,
            price: { amount: true, currency: true, otherPrices: true },
        },
    });
    return ((0, jsx_runtime_1.jsx)(views_1.GridLayoutOfThreeView, { className: className, layout: layout, data: data, render: (product) => ((0, jsx_runtime_1.jsx)(productTile_1.ProductTileView, { className: "animated fadeIn", product: product })) }));
}
exports.ProductLayoutOfThree = ProductLayoutOfThree;
